import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';
import { ErrorMessageComponent } from '../cross-utils/error-message/error-message.component';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    private dialog: MatDialog,
    private translate: TranslateService) { 
  }
  
  public async showError(msg: string) {
    const title = msg; // this.translate.instant('errors.warning');
    let msg2 = msg;
    if (msg && typeof (msg) === 'string' && (
      msg.indexOf('errors.') >= 0 ||
      msg.indexOf('messages.') >= 0 ||
      msg.indexOf('general.') >= 0 ||
      msg.indexOf('login.') >= 0 ||
      msg.indexOf('calendar.') >= 0)) {
      msg2 = msg; // this.translate.instant(msg);
    }
    const dialogRef = this.dialog.open(ErrorMessageComponent, {
      data: {
        title: title,
        message1: msg2
      },
      width: '400px',
    });

  }
  public To2digit(n: number) {
    return ('00' + n).slice(-2);
  }

  formatLocaleDate(dt: DateTime) {
    return this.To2digit(dt.day) + '/' + this.To2digit(dt.month) + '/' + dt.year;
  }

  getShortWeekDay(num: number): string {
    let d = '';
    switch (num) {
      case 0: d = this.translate.instant('calendar.sun'); break;
      case 1: d = this.translate.instant('calendar.mon'); break;
      case 2: d = this.translate.instant('calendar.tue'); break;
      case 3: d = this.translate.instant('calendar.wed'); break;
      case 4: d = this.translate.instant('calendar.thu'); break;
      case 5: d = this.translate.instant('calendar.fri'); break;
      case 6: d = this.translate.instant('calendar.sat'); break;
      case 7: d = this.translate.instant('calendar.sun'); break;
    }
    return d;
  }

  getLongWeekDay(num: number): string {
    let d = '';
    switch (num) {
      case 0: d = this.translate.instant('calendar.sunday'); break;
      case 1: d = this.translate.instant('calendar.monday'); break;
      case 2: d = this.translate.instant('calendar.tuesday'); break;
      case 3: d = this.translate.instant('calendar.wednesday'); break;
      case 4: d = this.translate.instant('calendar.thursday'); break;
      case 5: d = this.translate.instant('calendar.friday'); break;
      case 6: d = this.translate.instant('calendar.saturday'); break;
      case 7: d = this.translate.instant('calendar.sunday'); break;
    }
    return d;
  }

  getShortMonth(num: number): string {
    let d = '';
    switch (num) {
      case 1: d = this.translate.instant('calendar.jan'); break;
      case 2: d = this.translate.instant('calendar.feb'); break;
      case 3: d = this.translate.instant('calendar.mar'); break;
      case 4: d = this.translate.instant('calendar.apr'); break;
      case 5: d = this.translate.instant('calendar.may'); break;
      case 6: d = this.translate.instant('calendar.jun'); break;
      case 7: d = this.translate.instant('calendar.jul'); break;
      case 8: d = this.translate.instant('calendar.aug'); break;
      case 9: d = this.translate.instant('calendar.sep'); break;
      case 10: d = this.translate.instant('calendar.oct'); break;
      case 11: d = this.translate.instant('calendar.nov'); break;
      case 12: d = this.translate.instant('calendar.dec'); break;
    }
    return d;
  }

  getLongMonth(num: number): string {
    let d = '';
    switch (num) {
      case 1: d = this.translate.instant('calendar.january'); break;
      case 2: d = this.translate.instant('calendar.february'); break;
      case 3: d = this.translate.instant('calendar.march'); break;
      case 4: d = this.translate.instant('calendar.april'); break;
      case 5: d = this.translate.instant('calendar.may_'); break;
      case 6: d = this.translate.instant('calendar.june'); break;
      case 7: d = this.translate.instant('calendar.july'); break;
      case 8: d = this.translate.instant('calendar.august'); break;
      case 9: d = this.translate.instant('calendar.september'); break;
      case 10: d = this.translate.instant('calendar.october'); break;
      case 11: d = this.translate.instant('calendar.november'); break;
      case 12: d = this.translate.instant('calendar.december'); break;
    }
    return d;
  }

  public ReplaceAll(str: string, search: string, replacement: string) {
    return str.split(search).join(replacement);
  }

}
